"use client";

import { useTranslations } from "next-intl";

const FEATURE_KEYS = [
	{ n: 1, titleKey: "feature1Title", descKey: "feature1Desc" },
	{ n: 2, titleKey: "feature2Title", descKey: "feature2Desc" },
	{ n: 3, titleKey: "feature3Title", descKey: "feature3Desc" },
	{ n: 4, titleKey: "feature4Title", descKey: "feature4Desc" },
] as const;

function StarIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
		</svg>
	);
}

/**
 * Plastic Injection Molding：Why Choose Us — 顶部绿块+文案整体居中、不占满宽；下排 4 卡
 */
export default function PlasticInjectionMoldingWhyChoose() {
	const t = useTranslations("plasticInjectionMoldingWhyChoose");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				{/* 顶部：绿块 + 文案作为一组水平居中，max-width 限制宽度 */}
				<div className="mb-6 flex justify-center sm:mb-8 md:mb-10 lg:mb-12">
					<div className="flex w-full max-w-[920px] flex-col gap-7 sm:max-w-[960px] lg:flex-row lg:items-start lg:gap-10 xl:max-w-[1000px] xl:gap-12">
						{/* 绿块：更小更紧凑；小屏自身居中 */}
						<div className="mx-auto flex size-[156px] shrink-0 flex-col items-center justify-center rounded-xl bg-[#76a734] px-2.5 py-4 text-center text-white shadow-md sm:size-[172px] sm:px-3 sm:py-5 md:size-[180px] lg:mx-0">
							<StarIcon className="mb-1.5 h-5 w-5 text-white sm:mb-2 sm:h-5 sm:w-5" />
							<p className="mb-1 text-[10px] font-medium leading-tight sm:text-[11px]">{t("badgeTopText")}</p>
							<p className="mb-1 text-lg font-bold leading-none sm:mb-1.5 sm:text-xl md:text-2xl">
								{t("badgeMainText")}
							</p>
							<p className="text-[10px] font-medium leading-tight sm:text-[5px]">{t("badgeBottomText")}</p>
						</div>

						<div className="w-full min-w-0 flex-1 text-left">
							<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
								<span className="block">{t("titleLine1")}</span>
								<span className="mt-0.5 block sm:mt-1">{t("titleLine2")}</span>
							</h2>
							<p className="text-sm leading-relaxed text-black md:text-base">{t("introParagraph1")}</p>
							<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
								{t("introParagraph2")}
							</p>
						</div>
					</div>
				</div>

				{/* 底部：4 列卡片 */}
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
					{FEATURE_KEYS.map((key) => (
						<div
							key={key.titleKey}
							className="flex flex-col bg-white p-6 pt-0 shadow-[0_2px_12px_rgba(0,0,0,0.08)]"
						>
							<div
								className="mb-4 flex h-10 w-10 shrink-0 items-center justify-center bg-[#76a734] text-base font-bold text-white sm:mb-5"
								aria-hidden
							>
								{key.n}
							</div>
							<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">{t(key.titleKey)}</h3>
							<p className="text-sm leading-relaxed text-black md:text-base">{t(key.descKey)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
